import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import React from "react";

const About = () => {
  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        About GameApp
      </Typography>
      <Typography variant="body1" paragraph>
        GameApp is a React-based web application that allows users to search and explore video games using the RAWG API.
      </Typography>
      <Typography variant="h5" gutterBottom>
        Tech Stack
      </Typography>
      <List>
        {[
          "React 18",
          "Material-UI (MUI)",
          "React Router v6",
          "RAWG Video Games Database API",
          "AWS Amplify (hosting & CI/CD)",
          "PostCSS & PurgeCSS (CSS optimization)",
        ].map((item) => (
          <ListItem key={item}>
            <ListItemIcon>
              <CheckCircleIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>
      <Typography variant="body2" sx={{ mt: 4 }}>
        © 2025 by Stanley Luong
      </Typography>
    </Box>
  );
};

export default About; 